<script>
import BulmaStylesNoSV from './BulmaStylesNoSV.svelte';
import BulmaStyles from './BulmaStyles.svelte';
import { linkCSS } from "./libraries/linkCSS";
import TripodIcons from 'tripod-styles/src/TripodIcons.svelte';
export let set_as_sv = true;
linkCSS([
    "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css",
    "https://fonts.googleapis.com/css2?family=Montserrat:wght@200;400;500;600;700&display=swap"
]);

</script>
{#if set_as_sv}
    <BulmaStyles />
    {:else}
        <BulmaStylesNoSV />
{/if}

<TripodIcons />
<svelte:head>
    <style>
        :root{
            --color-primary: #296FFF;
            --color-primary-gradient: linear-gradient(90deg,  #2A6FFF 0%, #15B8FF 100%);
            --color-primary-gradient45: linear-gradient(45deg,  #2A6FFF 0%, #15B8FF 100%);
            --color-primary-gradient-inverted: linear-gradient(90deg,  #15B8FF 0%, #2A6FFF 100%);
            --color-secundary: #15B8FF;
            --color-black: #1D2C3B;
            --color-light-hover: #E1E8ED;
            --color-mid-grey: #b4c0c9;
            --color-dark-grey: #AAB8C2;
            --color-warning: #FDB703;
            --color-yellow: #FDB703;
            --color-greyDarker: #1D2C3B;
            --color-grey: #424B54;
            --color-orange: #EAA34F;
            --color-warning-alt-2: #EAD14F;
            --color-grey-alt1: #EAF1FF80;
            --color-grey-alt2: #EAF1FF;
            --color-grey-alt3: #CED5DC;
            --color-lighter: #424B54;
            --color-lightGrey: #f5f8fa;
            --color-lightMidGrey: #b4c0c9;
            --color-extralightGrey: #e1e8ed;
            --grey-body: #F5F6FA;
            --color-darkGrey: #0d1440;
            --color-error: #EA564F;
            --color-danger: #EA564F;
            --color-info: #424B54;
            --color-link: #2f6af7;
            --color-blue: #424B54;
            --color-blue-second: #2f6af7;
            --color-success: #0A8A10;
            --color-green: #0A8A10;
            --color-transparent-gray: #B4C0C9;
            --color-alt-1: #2691ec;    
            --color-primary-alt-1: #EAF1FF;
            --color-success-alt-1: #E7F8EC;
            --color-warning-alt-1: #FFF8E6;
            --color-danger-alt-1: #FDEFEE;
            --color-info-alt-1: #EAF1FF;
            --color-bg-modals: rgba(29, 44, 59, 0.4);
            --grid-maxWidth: 120rem;
            --grid-gutter: 2rem;
            --font-size: 1.6rem;
            --padding-normal: .75rem;
            --padding-sides-normal: 0 .75rem;
            --padding-updown-normal: .75rem 0;
            --font-family: "Montserrat", "Calibri", sans-serif !important;
            --swiper-theme-color: #203b8a !important;
            --color-nav-bar-border: #E1E8ED;/* color nav bar para border, según mockup (pendiente por actualizar) */
            --size-header-bar: 3.25rem;
            --margin-top-header: 3.593rem;
            --min-height-row: 468px;
            --max-width-row: 70vw;
            --max-width-default-layout: 1440px;
            --max-width-medium-layout: 600px;
            --spacing-size-large: 5em;
            --spacing-size-medium: 2.5em;
            --spacing-size-small: 1.25em;
            --sidebar-size: 64px;
            --header-size: 60px;
            --navbar-mobile-size: 55px;
        }
    </style>
</svelte:head>
<style>
:global(.fw100){font-weight: 100 !important;}
:global(.fw200){font-weight: 200 !important;}
:global(.fw300){font-weight: 300 !important;}
:global(.fw400){font-weight: 400 !important;}
:global(.fw500){font-weight: 500 !important;}
:global(.fw600){font-weight: 600 !important;}
:global(.fw700){font-weight: 700 !important;}
:global(.fw800){font-weight: 800 !important;}
:global(.fw900){font-weight: 900 !important;}
:global(input.input){
	border: 1px solid #acb8c2;
}
:global(input.is-hovered.is-rounded), :global(button.button), :global(input.input), :global(.select select){
	border: 1px solid #AAB8C2;
}
:global(input.is-hovered.is-rounded:focus), :global(button.button:focus), :global(input.input:focus), :global(.select select:focus){
	border: 1px solid var(--color-primary);
    box-shadow: inherit;
}
:global(.box){
	border-radius: 20px !important;
    box-shadow: 5px 5px 32px rgb(205 205 205 / 29%);
}
:global(.pointer){
	cursor: pointer;
}
:global(.field-input){
    padding: 0 !important;
    margin: 0 !important;
    padding-bottom: 20px !important;
}

:global(.svelte-module button.is-primary.outlined-white), :global(.svelte-module button.outlined-white){
    border: 1px solid #fff;
}
:global(.has-shadow){
    box-shadow: 5px 5px 32px rgb(205 205 205 / 29%);
}
:global(.tag.is-primary.tripod), :global(.button.is-primary.tripod), :global(.button.is-primary.tripod:hover){
    background: transparent linear-gradient(8deg, #344fff 7%, #09E2FF 100%) 0% 0% no-repeat padding-box;
}
:global(.progress[value]::-webkit-progress-value){
    background: transparent linear-gradient(90deg, #344FFF 0%, #09E2FF 100%) 0% 0% no-repeat padding-box;
}
:global(.progress-bar progress){
	border: 1px solid rgba(0,0,0,0.15);
}
:global(.progress-bar progress::-webkit-progress-bar) {
   background-color: transparent;
}
:global(.progress-bar){
    margin-top: 1.25rem !important;
    padding: 1rem 0;
    position: relative;
    width: 100%;
    margin: auto;
}
:global(.steps-texts){
    position: absolute;
    width: 100%;
    text-align: center;
    top: 1rem;
    left: 0.45rem;
}
:global(.box){
    border-radius: 15px !important;
}
</style>